<template>
  <v-layout align-start>
    <v-flex>
      <v-toolbar flat color="transparent">
        <v-toolbar-title>Referentes</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click="abrirNuevo()">Nuevo Referente</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
          class="text-xs-center"
          v-model="search"
          append-icon="search"
          label="Busqueda"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="referents"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:item.active="{ item }">
          <v-chip small :color="item.active !== false ? 'green' : 'red'" dark>
            {{ item.active !== false ? 'Activo' : 'Inactivo' }}
          </v-chip>
        </template>
        <template v-slot:item.opciones="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-on="on" @click="editarItem(item)">edit</v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-on="on" @click="toggleActivar(item)">
                {{ item.active !== false ? 'block' : 'check_circle' }}
              </v-icon>
            </template>
            <span>{{ item.active !== false ? 'Desactivar' : 'Activar' }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on" @click="confirmarEliminar(item)">delete</v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="getReferents()">Resetear</v-btn>
        </template>
      </v-data-table>

      <!-- Modal Crear/Editar -->
      <v-dialog v-model="formModal" max-width="700">
        <v-card>
          <v-card-title class="headline primary white--text">
            {{ editando ? 'Editar Referente' : 'Nuevo Referente' }}
          </v-card-title>
          <v-card-text class="pt-4">
            <v-layout row wrap>
              <v-flex xs12 sm6 class="pa-2">
                <v-text-field v-model="form.name" label="Nombre *" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-text-field v-model="form.surname" label="Apellido *" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-text-field v-model="form.role" label="Rol/Cargo"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-text-field v-model="form.department" label="Departamento"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-text-field v-model="form.area" label="Area"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-text-field v-model="form.phone" label="Telefono"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-text-field v-model="form.email" label="Email"></v-text-field>
              </v-flex>
              <v-flex xs12 class="pa-2">
                <v-textarea v-model="form.bio" label="Biografia" rows="3"></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="formModal = false">Cancelar</v-btn>
            <v-btn color="primary" @click="guardar" :disabled="!form.name || !form.surname">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal Eliminar -->
      <v-dialog v-model="deleteModal" max-width="400">
        <v-card>
          <v-card-title class="headline">Confirmar eliminacion</v-card-title>
          <v-card-text>
            Estas seguro de que deseas eliminar al referente <strong>{{ itemToDelete ? (itemToDelete.name + ' ' + itemToDelete.surname) : '' }}</strong>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="deleteModal = false">Cancelar</v-btn>
            <v-btn color="red" dark @click="eliminar">Eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      search: "",
      formModal: false,
      deleteModal: false,
      editando: false,
      form: {},
      itemToDelete: null,
      headers: [
        { text: "Opciones", value: "opciones", sortable: false },
        { text: "Nombre", value: "name", sortable: true },
        { text: "Apellido", value: "surname", sortable: true },
        { text: "Rol", value: "role", sortable: true },
        { text: "Departamento", value: "department", sortable: true },
        { text: "Area", value: "area", sortable: true },
        { text: "Telefono", value: "phone", sortable: false },
        { text: "Email", value: "email", sortable: true },
        { text: "Estado", value: "active", sortable: true },
      ],
    };
  },
  created() {
    this.getReferents();
  },
  computed: {
    ...mapState("referentNamespace", ["referents"]),
  },
  methods: {
    ...mapActions("referentNamespace", [
      "getReferents", "saveReferent", "updateReferent",
      "activateReferent", "deactivateReferent", "deleteReferent"
    ]),
    abrirNuevo() {
      this.editando = false;
      this.form = {
        name: "", surname: "", role: "",
        department: "", area: "", phone: "",
        email: "", bio: ""
      };
      this.formModal = true;
    },
    editarItem(item) {
      this.editando = true;
      this.form = { ...item };
      this.formModal = true;
    },
    async guardar() {
      if (this.editando) {
        await this.updateReferent(this.form);
      } else {
        await this.saveReferent(this.form);
      }
      this.formModal = false;
    },
    async toggleActivar(item) {
      if (item.active !== false) {
        await this.deactivateReferent(item._id);
      } else {
        await this.activateReferent(item._id);
      }
    },
    confirmarEliminar(item) {
      this.itemToDelete = item;
      this.deleteModal = true;
    },
    async eliminar() {
      await this.deleteReferent(this.itemToDelete._id);
      this.deleteModal = false;
      this.itemToDelete = null;
    },
  },
};
</script>
